import { DotmSquare12 } from '@/components/ui/dotm-square-12';

export function PageLoader() {
  return (
    <div className="flex h-screen items-center justify-center bg-background">
      <DotmSquare12 />
    </div>
  );
}
